module.exports = __webpack_public_path__ + "img/116.8b2e7f84.jpg";